module.exports = __webpack_public_path__ + "static/img/shicao.dd915da.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/newCourse/shicao.png
// module id = Ifd0
// module chunks = 96